import React from 'react';
import CardBox from "../PalletIdProduction/CardBox";
import {MdOutlinePreview, MdPallet} from "react-icons/md";
import {FaRecycle} from "react-icons/fa6";
import {TbClockCancel, TbClockExclamation, TbQrcodeOff} from "react-icons/tb";
import {IoIosCloseCircle} from "react-icons/io";
import {FaWindowClose} from "react-icons/fa";
import {Link} from 'react-router-dom';

const Cards = ({data, selectedLocation}) => {
    let format1 = new Date().toUTCString();
    let format2 = new Date(new Date().getTime() - 99999999999).toUTCString();

    //
    // let  = objectDate.getDate() + "-" + objectDate.getMonth() + "-" + objectDate.getFullYear();
    // let  = objectDate2.getDate() + "-" + objectDate2.getMonth() + "-" + objectDate2.getFullYear();


    return (<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  gap-x-2">


        <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false`}>
            <CardBox title='پالت' icon={<MdPallet color='green' size={30}/>} bgColor='red'
                     value={`${data?.palletsCount || 0} (${data?.numberInPalletsCount || 0})`}/>
        </Link>


        {data?.palletQuarantineCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&QcStatus=[5%2C1]`}>
                <CardBox title='در حال بررسی'
                         icon={<MdOutlinePreview
                             color='blue'
                             size={30}/>}
                         bgColor='red'
                         value={data.palletQuarantineCount}/></Link> : null}

        {data?.palletReconstructCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&QcStatus=3`}>
                <CardBox title='بازسازی'
                         icon={<FaRecycle color='blue'
                                          size={30}/>}
                         bgColor='red'
                         value={data?.palletReconstructCount}/></Link> : null}

        {data?.palletExpredThresholdCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&toExpireThreshold=${format1}&fromExpireThreshold=${format2}`}>
                {/*todo filter date from 10 years ago to today in 23:59:59*/}

                <CardBox title='اخطار انقضا'
                         icon={<TbClockExclamation
                             color='orange'
                             size={30}/>}
                         bgColor='red'
                         value={data?.palletExpredThresholdCount}/>
            </Link> : null}


        {data?.palletCancleCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&PalletStatus=5`}>
                <CardBox title='ابطالی'
                         icon={<IoIosCloseCircle
                             color='red' size={30}/>}
                         bgColor='red'
                         value={data?.palletCancleCount}/></Link> : null}
        {data?.palletDestroyedCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&QcStatus=4`}>
                <CardBox title='امحا '
                         icon={<FaWindowClose
                             color='red' size={30}/>}
                         bgColor='red'
                         value={data?.palletDestroyedCount}/></Link> : null}
        {data?.palletConfusedCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&PalletStatus=6`}>
                <CardBox title='مخدوش '
                         icon={<TbQrcodeOff
                             color='red' size={30}/>}
                         bgColor='red'
                         value={data?.palletConfusedCount}/></Link> : null}


        {data?.palletExpiredCount ?
            <Link to={`/PalletStatus?locations=${selectedLocation}&IsExit=false&toExpireDate=${format1}&fromExpireDate=${format2}`}>


                <CardBox title='منقضی '
                         icon={<TbClockCancel
                             color='red' size={30}/>}
                         bgColor='red'
                         value={data?.palletExpiredCount}/></Link> : null}


    </div>);
};

export default Cards;